import { Controller } from "stimulus"

export default class extends Controller {

  static targets = ['child']

  connect() {
    this.size()
  }

  size() {
    for(let child of this.childTargets) {
      child.style.width = `${this.element.offsetWidth}px`
    }
  }
}
